<template>
  <div>
    <UserProfileHeader
      :user="user"
      @profile-updated="profileUpdated"
      @follow-toggled="followToggled(true)"
    />

    <!-- TABS -->
    <section>
      <div class="container">

        <ul class="nav nav-tabs default-tabs">
          <li class="nav-item">
            <router-link
              :to="{ name: 'followers.index', params: { username: this.$route.params.username } }"
              class="nav-link font-size-lg-medium"
              :class="{ active: this.$route.name === 'followers.index' }"
            >
              Seguidores
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              :to="{ name: 'following.index', params: { username: this.$route.params.username } }"
              class="nav-link font-size-lg-medium"
              :class="{ active: this.$route.name === 'following.index' }"
            >
              Seguindo
            </router-link>
          </li>
        </ul>

        <!-- CONTENT -->
        <div class="common-card-listing listing-rowed items-md-2-per-row items-lg-3-per-row mt-4 mt-lg-5">
          <ul class="list-wrap">
            <li
              class="list-item"
              v-for="person in list"
              :key="person.id"
            >
              <UserProfileCard
                :user="person"
                @follow-toggled="followToggled(false)"
              />
            </li>
          </ul>

          <div class="mt-3 text-center">
            <Button
              class="btn-outline-color2 btn-lg"
              :loading="loader"
              @click="loadMore"
              v-if="list && showButton"
            >
              Carregar mais
            </Button>
          </div>

        </div> <!-- END CONTENT -->
      </div>
    </section> <!-- END TABS -->
  </div>
</template>

<script>

import UsersService from '@/modules/users/services/users-service'
import FollowsService from '@/modules/follows/services/follows-service'
import variables from '@/mixins/variables'
import { mapState } from 'vuex'

import Button from '@/components/common/Button/Button.vue'
import UserProfileCard from '@/components/user/UserProfileCard.vue'
import UserProfileHeader from '@/components/user/UserProfileHeader.vue'

export default {
  mixins: [variables],
  components: {
    Button,
    UserProfileCard,
    UserProfileHeader
  },
  data () {
    return {
      user: null,
      listFollowers: null,
      listFollowing: null,
      pageFollowers: 1,
      pageFollowing: 1,
      type: null,
      loader: false,
      showButtonMoreFollowers: true,
      showButtonMoreFollowing: true
    }
  },
  metaInfo () {
    return {
      title: this.pageTitle
    }
  },
  computed: {
    current () {
      return this.type === 'following.index' ? 'following' : 'followers'
    },
    list () {
      return this.current === 'following' ? this.listFollowing : this.listFollowers
    },
    page () {
      return this.current === 'following' ? this.pageFollowing : this.pageFollowers
    },
    showButton () {
      return this.current === 'following' ? this.showButtonMoreFollowing : this.showButtonMoreFollowers
    },
    pageTitle () {
      return this.current === 'following' ? 'Seguindo' : 'Seguidores'
    },
    ...mapState('users', {
      authUser: state => state.user
    })
  },
  created () {
    this.type = this.$route.name
    this.getUser()
  },
  watch: {
    $route (to, from) {
      if (to.name === 'followers.index' || to.name === 'following.index') {
        this.type = to.name
        if (!this.list) this.getFollowList()
      }
    }
  },
  methods: {
    async getUser (getList = true) {
      try {
        const user = await UsersService.getUser(this.$route.params.username)
        this.user = user
        if (getList) this.getFollowList()
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
    },
    async getFollowList () {
      this.loader = true
      try {
        const list = await FollowsService.getFollowList(this.user.id, this.current, this.page)
        if (this.current === 'following') {
          this.listFollowing = this.listFollowing ? [...this.listFollowing, ...list] : list
          if (list.length === 0) this.showButtonMoreFollowing = false
        } else {
          this.listFollowers = this.listFollowers ? [...this.listFollowers, ...list] : list
          if (list.length === 0) this.showButtonMoreFollowers = false
        }
        this.loader = false
      } catch (error) {
        error.handleGlobally && error.handleGlobally()
      }
    },
    async loadMore () {
      if (this.current === 'following') {
        this.pageFollowing++
      } else {
        this.pageFollowers++
      }
      this.getFollowList()
    },
    profileUpdated () {
      this.getUser(false)
    },
    followToggled (followHeader = false) {
      // Only update the follower count if the current user is the logged user or if was the follow button on the header
      if ((this.authUser && this.user && this.authUser.id === this.user.id) || followHeader) this.getUser(false)
    }
  }
}
</script>
